<template>
  <v-dialog :value="show" persistent max-width="400">
    <v-card class="modal-card">
      <v-card-title class="pa-6">Абонемент закончился</v-card-title>
      <v-card-text class="pa-6">
        <v-alert type="info" dense>
          Это было последнее посещение по абонементу.
        </v-alert>
      </v-card-text>
      <v-card-actions class="px-6 py-5">
        <v-spacer></v-spacer>
        <v-btn depressed dark color="primary" @click="close" min-width="120" class="mx-2">Ок</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name   : 'CardExpiredDialog',
    model  : {
      prop: 'show',
    },
    props  : {
      show: {
        required: true
      }
    },
    methods: {
      close() {
        this.$emit('input', false);
      }
    }
  };
</script>

<style scoped>

</style>
